import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { Thematic } from '../../models/thematic.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-thumbnail-layer',
    templateUrl: './thumbnail-layer.component.html',
    styleUrls: ['./thumbnail-layer.component.css']
})
export class ThumbnailLayerComponent implements OnInit {

    @Output() private addThematicLI = new EventEmitter<Thematic>();
    @Output() private removeThematicLI = new EventEmitter<Thematic>();
    @Input() private elements = Array<Thematic>();

    private baseThematic: any;
    private queryParamThematic: any;
    private queryParams: any;

    constructor(private route: ActivatedRoute, private router: Router) {
        this.queryParams = this.route
            .queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.
                this.queryParamThematic = params['thematic'];
            });

    }
    ngOnInit() { }


    ngOnChanges(changes: SimpleChanges) {
        // changes.prop contains the old and the new value...
        if (changes.elements.currentValue.length > 0) {
            let position = 0;
            if (typeof (this.queryParamThematic) !== "undefined") {
                for (let i = 0; i < this.elements.length; i++) {
                    if (this.elements[i].id === this.queryParamThematic) {
                        this.elements[i].state = "active";
                        position = i;
                    } else {
                        this.elements[i].state = "unactive";
                    }
                }
            }
            this.baseThematic = this.elements[position];

        }
    }
    private toggleThematic(thematic: Thematic) {
        //Esborrem el base layer anterior
        this.removeThematicLI.emit(this.baseThematic);
        thematic.state = "active";
        this.baseThematic.state = "unactive";
        this.baseThematic = thematic;
        //Afegim el nou
        this.addThematicLI.emit(thematic);
    }

}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/thumbnail-layer/thumbnail-layer.component.ts